module.exports = __webpack_public_path__ + "static/teal-wave-bg-c21807031a777a87de92f3637a505f78.png";